import React from "react";
import { Box, Stack, Divider, Grid } from "@mui/material";
import StatsItem from "../../AcquireDashboard/Utilities/StatsItem";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { formatProactiveMetric } from "../../Proactive/Utilities/CampaignUtils";
import AttributionEmptyState from "./AttributionEmptyState";
import moduleStyles from "./styles.module.css";

export default function AttributionSummary({ data, loading }) {
  const formatMetric = (value) =>
      value === 0 ?  '-' :formatProactiveMetric(value)

  return (
    <Box mt={{ xs: "14px", sm: "20px" }}>
      <Stack
        sx={styles.root}
        direction={"column"}
        divider={<Divider orientation={"horizontal"} flexItem />}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1}
          sx={styles.header}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Box component={"h2"} sx={styles.headerTitle}>
              Attribution Summary
            </Box>

            <a
              href={"https://help.beremarkable.ai/en/articles/12415870-retain-ai-attribution-metrics"}
              target={"_blank"}
              rel="noopener"
              className={moduleStyles.helpLink}
            >
              <HelpOutlineIcon sx={{ fontSize: "20px", color: "#696969" }} />
            </a>
          </Box>
        </Stack>

        {loading && <AttributionEmptyState />}

        {!loading && (
          <Grid container columns={4} spacing={3} sx={styles.gridStyle}>
            <StatsItem
              label={"Ordered Within 5 Days"}
              entry={{ value: formatMetric(data?.orderedWithin5DaysRatio) }}
              descriptionChildren={
                <Box>Ordered within 5 days of Retain Al outreach</Box>
              }
            />
            <StatsItem
              label={"Ordered Recommended Category"}
              entry={{
                value: formatMetric(data?.orderedRecommendedCategoryRatio),
              }}
              descriptionChildren={
                <Box>
                  Includes{" "}
                  {formatProactiveMetric(data?.orderedRecommendedProductRatio)}{" "}
                  exact product winbacks
                </Box>
              }
            />
            <StatsItem
              label={"Last Touch"}
              entry={{ value: formatMetric(data?.lastTouchRatio) }}
              descriptionChildren={
                <Box>Retain AI outreach was final touch before order</Box>
              }
            />
            <StatsItem
              label={"Used Exact Discount Code"}
              entry={{ value: formatMetric(data?.usedExactDiscountCodeRatio) }}
              descriptionChildren={
                <Box>
                  {formatProactiveMetric(data?.usesAnyDiscountCodeRatio)} of all
                  winbacks used a discount code
                </Box>
              }
            />
          </Grid>
        )}
      </Stack>
    </Box>
  );
}

const styles = {
  root: {
    borderRadius: "10px",
    border: "1px solid #B6BEBF98",
    background: "#fff",
  },

  header: {
    alignItems: { xs: "flex-start", md: "center" },
    justifyContent: "space-between",
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 0 },
    minHeight: { xs: "auto", md: "73px" },
    zIndex: 10,
  },
  headerTitle: {
    m: 0,
    fontFamily: "FustatBold",
    fontSize: { xs: "14px", md: "19px" },
  },
  gridStyle: {
    position: "relative",
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 4 },
  },
  helpLink: {
    height: "19px",
  },
};
